const initialState = {
  data:{},
  search:'',
  filter:[],
  sort:{
    field:'atype_desc',
    asc:1
  }
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_ATYPES':
      return {
        ...state,
        data:  action.payload
      }
    case 'SORT_ATYPES':
      return {
        ...state,
        sort: action.sort
      }
    case 'SEARCH_ATYPES':
      return {
        ...state,
        search: action.search
      }
    case 'EDIT_ATYPE':
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.atype_id]:action.payload
        }
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/atypes.js